import { Inject } from '@odinjs/odin';

import { AutocompleteAPI,  FormAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { FragmentNames  } from '../../../../../codegen';
import { Endpoint } from '../../../../../constants/endpoints';
import { ApplicationRoute } from '../../../../../constants/routes';
import BaseController from '../../../../BaseController';
import InformationBarUtils from '../../../../commons/header/information-bar-header-utils';
import MedicationService from '../../../services/medication-service';
import { ReasonType } from '../../adult-tpn/adult-tpn-types';
import { MedicineAndSolutionsParams } from '../../medicine-and-solutions/medicine-and-solutions-params';
import { BladderIrrigationReverseAliases } from '../../../../../codegen/constants/aliases/bladder-irrigation-reverse-aliases';
import { AdminModalsService } from '../../../../../controllers/adep/services/admin-modals-service';
import { YesNoType } from '../../../../../utils/enum-utils';

@Controller({ component: BladderIrrigationReverseAliases.BLADDER_IRRIGATION_REVERSE_LAYOUT, fragment: FragmentNames.BLADDER_IRRIGATION_REVERSE })
export default class NursingInterventionsReverseController extends BaseController {

  @Inject(BladderIrrigationReverseAliases.BLADDER_IRRIGATION_REVERSE_FORM)
  private formApi!: FormAPI;

  @Inject(BladderIrrigationReverseAliases.PANEL_LOADER)
  private feedbackPanelLoaderApi!: PanelAPI;

  @Inject(BladderIrrigationReverseAliases.AUTOCOMPLETE_REASON_LIST)
  private reasonAutocompleteApi!: AutocompleteAPI;

  @OnMount(BladderIrrigationReverseAliases.BLADDER_IRRIGATION_REVERSE_LAYOUT)
  handleMountLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId });
    InformationBarUtils.collapsedBar = true;
  }

  @OnBeforeCancel(BladderIrrigationReverseAliases.BLADDER_IRRIGATION_REVERSE_FORM)
  handleCancelForm(): void {
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit(BladderIrrigationReverseAliases.BLADDER_IRRIGATION_REVERSE_FORM)
  handleSubmitForm(): void {
    this.reverse();
  }

  private reverse(): void {
    this.feedbackPanelLoaderApi.setVisible(true);
    const body = this.getBody();
    const irrigationSequence = Number(MedicineAndSolutionsParams.params.nrSequenceId)
    HttpService.post(Endpoint.EMAR_POST_REVERSE_BLADDER_IRRIGATION, { irrigationSequence }, { body })
      .then(() => {
        MedicationService.showToast(MessageService.translate('text.revert-event'), ToastLevel.SUCCESS)
        this.goToTimeline()
      })
      .catch((error) => {
        const message = error.body.messageDescription;
        const errorMessage = error.body.errors.join('; ')
        MedicationService.showToast(message ?? errorMessage, ToastLevel.ERROR)
      }).finally(() => {
        this.formApi.setLocked(true);
        this.feedbackPanelLoaderApi.setVisible(false)
      });
  }

  private getBody(): Record<string, Value> {
    const reasonSelected = this.reasonAutocompleteApi.getValue() as unknown as ReasonType;
    return {
      encounterId: MedicineAndSolutionsParams.params.encounterId,
      isLoop: YesNoType.YES,
      prescriptionNumber: MedicineAndSolutionsParams.params.nrPrescriptionId,
      reasonId: reasonSelected.sequenceNumber,
    } as Record<string, Value>;
  }

  private goToTimeline(): void {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION, {
      encounterId,
      patientId,
    });
    applicationContext.clearNavigationStack();
    AdminModalsService.redirectToTimeline(FragmentNames.BLADDER_IRRIGATION_REVERSE);
    AdminModalsService.redirectToTimeline(FragmentNames.BLADDER_IRRIGATION_VIEWER);
  }
}